import script from "./info.vue?vue&type=script&lang=ts&setup=true"
export * from "./info.vue?vue&type=script&lang=ts&setup=true"

import "./info.vue?vue&type=style&index=0&id=402a7336&lang=css"
import "./info.vue?vue&type=style&index=1&id=402a7336&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-402a7336"]])

export default __exports__